import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { DatePipe } from '@angular/common';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import * as moment from 'moment';

@Component({
  selector: 'app-ia-marks',
  templateUrl: './ia-marks.component.html',
  styleUrls: ['./ia-marks.component.scss']
})
export class IAMarksComponent implements OnInit {

 IAMarksForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  APIService: any;
  StudentTable: [];
  colrChang = false;
  CountTable: [];
  StuArray: FormArray;
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  SaveBtn = false;
  UpdateBtn = false;
  hasExistingMarks = false;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  assignTableData: any[];
  Student: any;
  errMsg: any;
  currentDate: Date;
  // jsonData: any;
  examList
  filteredListExam
  subjectList = []
  filteredsubjectList
  isBranch = false;
  Iamarks = 0
  BranchList
  filteredListBranch
  emid
  subcode
  savedpayload: any;
  SubMarkList: any;
  HeadList: any;
  filteredListHead: any;
  headcode: any;
  IaAtdCreate = true;
  IaAtdUpdate = true;
  userPermission: any;
  UserCollege
  utp: string;
  saveDisable: boolean;
  updateDisable: boolean;
  IamarksCounts
  IsFile = false;
  passMarks: any;
  maxMarks: any;
  status: any;
  finalPayload: any[] = [];
  finalPayloadUpdate: any[] = [];
  errMsgInvalid: boolean[] = []; // Initialize an array to track invalid states
  head: any;
  sub: any;
  message: any;
  closeMessage: any;
  sessionNo: any;
  coCode: any;
  downloadData: any[];

  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService, public datepipe: DatePipe,

  ) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Student IA Iamarks' && element.PCreate == false) {
          this.IaAtdCreate = false;
        }
        if (element.PageName == 'Student IA Iamarks' && element.PUpdate == false) {
          this.IaAtdUpdate = false;
        }

      });
    }
    this.IsFile = false
    this.saveDisable = false
    this.updateDisable = false
    this.SaveBtn = false;
    this.UpdateBtn = false;
    this.Table = false
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    this.Iamarks = 0
    let id = ''
    this.submitButton = true;
    this.editButton = false;
    this.IAMarksForm = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
      EmId: new FormControl(''),
      SubCode: new FormControl(''),
      EsId: new FormControl(''),
      Branch: new FormControl(''),
      EsParentId: new FormControl(''),
      StuArray: new FormArray([]),
      Iamarks: new FormControl(''),
    });
    this.fetchSession();
    // this.getClg();
    this.currentDate = new Date();
  }

  getStuArrayControls() {
    return (this.IAMarksForm.get('StuArray') as FormArray).controls;
  }



  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.filteredListCourse = [];
    this.filteredCollegeList = [];
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    payload['SnDefault'] = '';
    payload['SnNo'] = '';
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
    })
  }

  getClg(data: any) {
    this.sessionId = data
    if (this.userPermission[0].CgUi == 'C') {
      this.UserCollege = this.userPermission[0].CgId;
    }
    else {
      this.UserCollege = ''
    }
    this.Table = false;
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.subcode = '';
    this.filteredsubjectList = [];
    this.filteredListExam = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
    })
  }

  getCourse(data) {
    this.CgCode = data.CgCode
    this.sessionNo = data.SnNo
    this.closeMessage = '';
    this.message = ''
    this.finalPayload = []
    let payload2 = this.IAMarksForm.value
    this.Table = false
    this.UpdateBtn = false;
    this.SaveBtn = false;
    this.isBranch = false;
    this.Table = false;
    this.IAMarksForm.controls['course'].setValue('');
    this.IAMarksForm.controls['EmId'].setValue('');
    this.IAMarksForm.controls['EsParentId'].setValue('');
    this.IAMarksForm.controls['EsId'].setValue('');
    this.filteredListExam = [];
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.examList = []
    this.CourseList = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = payload2.college;
    payload['SessionId'] = payload2.SessionId;

    // getSessionColgCo
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else {
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
    })
  }

    getExamList(e) {

    this.coCode = e.CoCode
    // this.getIaMarkUserData();
    this.closeMessage = ''
    this.message = ''
    this.finalPayload = []
    this.Table = false;
    this.spinner.show();
    this.filteredsubjectList = [];
    this.examList = []
    this.isBranch = false;
    const payload = {};
    payload['EmCoCode'] = e.CoCode;
    this.filteredsubjectList = [];
    this.examList = []
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.examList = res.data;
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
      // this.umsService.openSnackbar(ERROR.error.message);

    });
  }

  //   getStr(e) {
  //   this.closeMessage = ''
  //   this.message = ''
  //   this.finalPayload = []
  //   this.spinner.show();
  //   this.Table = false;
  //   this.filteredsubjectList = [];
  //   this.subjectList = []
  //   this.HeadList = [];
  //   let payload = {};
  //   this.emid = e.EmId
  //   payload['EsEmId'] = this.emid;
  //   payload['EsStrId'] = this.IAMarksForm.value.Branch;
  //   this.umsService.getExamSubMapFetch(payload).subscribe(res => {
  //     this.spinner.hide();
  //     if (res.status) {
  //       res.data.children.forEach(element => {
  //         if (element.EsType == 'S') {
  //           this.subjectList.push(element)
  //         }
  //         else if (element.EsType == 'G') {
  //           element.children.forEach(grpSub => {
  //             this.subjectList.push(grpSub)
  //           });
  //         }
  //         this.filteredsubjectList = this.subjectList.slice();

  //       });
  //     }
  //     else {
  //       this.subjectList = [];
  //       this.filteredsubjectList = [];

  //     }

  //   }, (ERROR: HttpErrorResponse) => {
  //     this.subjectList = [];
  //     this.filteredsubjectList = [];
  //   });
  // }

    subjectClick(data) {
    this.closeMessage = ''
    this.message = ''
    this.spinner.show();
    this.HeadList = [];
    this.filteredListHead = [];
    this.Table = false;
    this.subcode = data.EsCode;
    this.finalPayload = []
    const payload = {};
    payload['EsId'] = data.EsId;
    this.umsService.getStuIASub(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.HeadList = res.data;
        // this.passMarks = this.HeadList[0].EsPassMarks
        // this.maxMarks = this.HeadList[0].EsMaxMarks
        this.head = this.HeadList[0].EsCode
        this.filteredListHead = this.HeadList.slice();
      }
      else {
        this.HeadList = [];
        this.IAMarksForm.controls['EsId'].setValue('');

      }

    }, (ERROR: HttpErrorResponse) => {
      this.HeadList = [];
      this.IAMarksForm.controls['EsId'].setValue('');
    })
  }




  getHeadCode(data) {
    this.headcode = data.EsCode;
    this.ShowTable();
    this.IsFile = true
    this.finalPayload = []
    this.passMarks = data.EsPassMarks
    this.maxMarks = data.EsMaxMarks
    this.getSessionCutOff()
  }

  ShowTable() {
    // this.spinner.show();
    this.Table = false;
    let payload2 = this.IAMarksForm.value
    this.StuArray = this.IAMarksForm.get('StuArray') as FormArray;
    this.StuArray.clear();
    this.assignTableData = [''];
    this.StudentTable = [];
    const payload = {};
    payload['SessionId'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['EsCode'] = this.subcode;
    payload['HeadCode'] = this.headcode;
    payload['CgCode'] = payload2.college
    payload['EmId'] = payload2.EmId
    payload['UserId'] = sessionStorage.getItem('userId')
    payload['LoginLevel'] = ''
    // payload['EsParentId'] = payload2.EsParentId
    this.umsService.getStuIAMarks(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {

        this.assignTableData = [''];
        this.Table = true;
        this.assignTableData = res.data;
        // this.SaveBtn = false;
        // this.UpdateBtn = true;

        // Check if marks already exist in DB
        this.hasExistingMarks = res.data.some(
          element => element.IAMarks !== null && element.IAMarks !== undefined
        );

        if (this.hasExistingMarks) {
          // If any student has IAMarks, enable the Update button and disable the Save button
          this.SaveBtn = false;
          this.UpdateBtn = true;
        } else {
          // If no IAMarks are present, disable the Update button and enable the Save button
          this.SaveBtn = true;
          this.UpdateBtn = false;
        }

        this.assignTableData.forEach((element, i) => {
          const creds = this.IAMarksForm.get('StuArray') as FormArray;
          creds.push(
            this.fb.group({
              SrNo: new FormControl(i + 1),
              RgNo :new FormControl(element['StuRgNo']),
              Name: new FormControl(element['StuFirstNameEng'] + " " + element['StuMidNameEng'] + " " + element['StuLastNameEng']),
              Iamarks: new FormControl(element['IAMarks'], Validators.required),
              Status: new FormControl(element['IAMarksStatus']),
              StuId: new FormControl(element['StuId']),
              StuIAMarksId: new FormControl(element['StuIAMarksId']),
              SctId: new FormControl(element['SctId']),
              // AttendIAId: new FormControl(element['AttendIAId']),
            })
          );
        });

        // Listen for changes AFTER form array is built
        this.IAMarksForm.valueChanges.subscribe(() => {
        if (this.hasExistingMarks) {
          this.SaveBtn = false;
          this.UpdateBtn = true;
        }
      });

       
        // this.getStuMarkSet()

      } else {
        this.SaveBtn = false;
        this.UpdateBtn = false;
        this.closeMessage = ''
        this.message = ''
        let data = {}
        data['message'] = 'Subject is not assigned to a logged-in user'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);


      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.SaveBtn = true;
      this.UpdateBtn = false;
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      // this.umsService.openSnackbar(ERROR.error.message);

    });

  }

  getSessionCutOff() {
    this.spinner.show();
    let payload2 = this.IAMarksForm.value

    const payload = {};
    payload['SessionID'] = payload2.SessionId;
    payload['CoCgCgCode'] = payload2.college;
    payload['CoCgCoCode'] = payload2.course;
    payload['InCode'] = 'IAMar';
    payload['EmId'] = payload2.EmId;
    let iserror = false;
    this.umsService.findSessionCutOff(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        // this.Table = true;
        const data = res.data[res.data.length - 1];
        // Check if the response has the necessary data
        if (data && data.CutOffDateFrom && data.CutOffDate) {
          const cutOffDateFrom = new Date(data.CutOffDateFrom);
          const cutOffDate = new Date(data.CutOffDate);
          const currentDate = new Date();

          // Check if today's date is within the range
          if (currentDate >= cutOffDateFrom && currentDate <= cutOffDate) {
            // Show the button because we are within the cutoff range
            // this.SaveBtn = true;
            this.message = `Session cut off dates are ${moment(cutOffDateFrom).format('DD/MM/YYYY')} to ${moment(cutOffDate).format('DD/MM/YYYY')}`
          } else {
            // Hide the button because we are outside the cutoff range
            this.SaveBtn = false;
            this.UpdateBtn = false;
            this.closeMessage = `Session cut off dates are ${moment(cutOffDateFrom).format('DD/MM/YYYY')} to ${moment(cutOffDate).format('DD/MM/YYYY')} now session is closed`
          }
        }
      }
      else {
        // this.Table = false;
        this.SaveBtn = false;
        this.UpdateBtn = false;
        this.closeMessage = 'The session cutoff has not been added.'
      }
    }, (ERROR: HttpErrorResponse) => {
      iserror = true;
      this.errMsg = ERROR.error.message

    });
  }


  onInputChange2(val, i) {
    const tempData = val.target.value;


    // Reset error message for the specific index
    this.errMsgInvalid[i] = false;

    // Check if `iamarks` or `Status` has a value
    const stuArray = this.IAMarksForm.value.StuArray;

    if (stuArray && (stuArray[0].iamarks || stuArray[0].Status)) {
        if (tempData > this.maxMarks || tempData === '') {
            this.errMsgInvalid[i] = true; // Set error for this specific input
            this.UpdateBtn = false;
        } else {
            this.UpdateBtn = true;
        }
    } else {
        if (tempData > this.maxMarks || tempData === '') {
            this.errMsgInvalid[i] = true; // Set error for this specific input
            this.SaveBtn = false;
        } else {
            this.SaveBtn = true;
        }
    }

    // Check if tempData is greater than or equal to passMarks
    if (tempData >= this.passMarks && tempData <= this.maxMarks) {
        this.status = 'P'; // Passed
    } else if (tempData < this.passMarks) {
        this.status = 'F'; // Failed
        this.errMsg = true; // Show error message if marks are less than passMarks
    }
  }


  redirect(to): void {
    this.router.navigate([to]);
  }

  errorcheckR(i) {
    return i.controls['Iamarks'].touched && i.controls['Iamarks'].errors?.pattern
  }

  LessThan(i) {
    return i.controls['Iamarks'].touched && i.controls['Iamarks'].errors?.max
  }

  Save() {
    if (this.IAMarksForm.invalid) {
      this.IAMarksForm.get('SessionId').markAsTouched();
      this.IAMarksForm.get('college').markAsTouched()
      this.IAMarksForm.get('course').markAsTouched();
      this.IAMarksForm.get('EmId').markAsTouched();
      this.IAMarksForm.get('EsParentId').markAsTouched();
      this.IAMarksForm.get('EsId').markAsTouched();
      this.StuArray = this.IAMarksForm.get('StuArray') as FormArray;
      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Iamarks').markAsTouched();
        })
      }
    }
    else {
      this.SaveIaMarks()
    }
  }

  SaveIaMarks() {
    this.spinner.show();
    this.submitpayload = this.IAMarksForm.value;
    this.IAMarksForm.controls.StuArray as FormArray;
    this.StuArray = this.IAMarksForm.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    // let payload = abcd.value;
    let iserror = false;
    this.finalPayload = []
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionID'] = this.submitpayload['SessionId'];
        // payload['CgCode'] = this.submitpayload['college'];
        payload['CoCode'] = this.submitpayload['course'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['EsId'] = this.submitpayload['EsId'];
        payload['EsParentId'] = this.submitpayload['EsParentId'];
        payload['HeadCode'] = this.headcode;
        payload['SubCode'] = this.subcode;
        payload['Branch'] = this.submitpayload['Branch'];
        payload['StuID'] = element.StuId;
        payload['IAMarks'] = parseInt(element.Iamarks);
        payload['IAMarksStatus'] = element.Iamarks >= this.passMarks && element.Iamarks <= this.maxMarks ? 'P' : 'F';
        payload['SctId'] = element.SctId || 0;
        payload['UserID'] = parseInt(sessionStorage.getItem('userId'));
        payload['EntryDateTime'] = this.currentDate;
        this.finalPayload.push(payload);
      });

      this.umsService.saveStuIaMarksSet(this.finalPayload).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          let data = {}
          data['message'] = "Submitted Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.ShowTable()
          });
        }
        else {
          let data = {}
          data['message'] = this.errMsg
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.ShowTable()
          });

        }
      }, (ERROR: HttpErrorResponse) => {
        iserror = true;
        this.errMsg = ERROR.error.message

      });
    })

  }

  update() {
    if (this.IAMarksForm.invalid) {
      this.IAMarksForm.get('SessionId').markAsTouched();
      this.StuArray = this.IAMarksForm.get('StuArray') as FormArray;
      this.IAMarksForm.get('EmId').markAsTouched();
      this.IAMarksForm.get('EsParentId').markAsTouched();
      this.IAMarksForm.get('EsId').markAsTouched();

      if (this.StuArray.invalid) {
        this.StuArray.controls.forEach(element => {
          element.get('Iamarks').markAsTouched();
        })
      }
    }
    else {
      this.updateAtd()
    }
  }

  updateAtd() {
    // updateStdAtd
    this.spinner.show();
    this.submitpayload = this.IAMarksForm.value;

    this.IAMarksForm.controls.StuArray as FormArray;
    this.StuArray = this.IAMarksForm.get('StuArray') as FormArray;
    this.Student = this.StuArray.value
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      this.Student.forEach((element, index, array) => {
        let payload = {};
        payload['SessionID'] = this.submitpayload['SessionId'];
        // payload['CgCode'] = this.submitpayload['college'];
        payload['CoCode'] = this.submitpayload['course'];
        payload['EmId'] = this.submitpayload['EmId'];
        payload['EsId'] = this.submitpayload['EsId'];
        payload['EsParentId'] = this.submitpayload['EsParentId'];
        payload['HeadCode'] = this.headcode;
        payload['SubCode'] = this.subcode;
        payload['Branch'] = this.submitpayload['Branch'];
        payload['StuID'] = element.StuId;
        payload['IAMarks'] = parseInt(element.Iamarks);
        payload['StuIAMarksId'] = element.StuIAMarksId;
        payload['IAMarksStatus'] = element.Iamarks >= this.passMarks && element.Iamarks <= this.maxMarks ? 'P' : 'F';
        payload['SctId'] = element.SctId || 0;
        payload['UserID'] = parseInt(sessionStorage.getItem('userId'));
        payload['EntryDateTime'] = this.currentDate;

        this.finalPayloadUpdate.push(payload);

      });
      this.umsService.updateStuIaMarksSet(this.finalPayloadUpdate).subscribe(res => {
        this.spinner.hide();
        if (res.status) {
          let data = {}
          data['message'] = "Updated Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.ShowTable()
          });
        }
        else {
          let data = {}
          data['message'] = this.errMsg
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe((result) => {
            this.ShowTable()
          });

        }
      }, (ERROR: HttpErrorResponse) => {
        iserror = true;
        this.errMsg = ERROR.error.message

      });
    });
    // bar.then(() => {
    //   if (iserror == false) {
    //     let data = {}
    //     data['message'] = "Updated Successfully"
    //     data['title'] = 'Information'
    //     data['icon'] = 'fas fa-check'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //     this.dialogRef.afterClosed().subscribe((result) => {
    //       this.ShowTable()
    //     });
    //   } else {
    //     let data = {}
    //     data['message'] = this.errMsg
    //     data['title'] = 'Alert'
    //     data['icon'] = 'fas fa-close'
    //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    //     this.dialogRef.afterClosed().subscribe((result) => {
    //       this.ShowTable()
    //     });
    //   }
    // });
  }




  getDownloadData(){
    let payload2 = this.IAMarksForm.value
    this.downloadData = []
    const payload = {};
    payload['SessionId'] = payload2.SessionId;
    payload['CoCode'] = payload2.course;
    payload['EsCode'] = '';
    payload['HeadCode'] = '';
    payload['CgCode'] = payload2.college
    payload['EmId'] = payload2.EmId
    payload['UserId'] = sessionStorage.getItem('userId')
    payload['LoginLevel'] = ''
    this.umsService.getStuIAMarks(payload).subscribe((res) => {
      if(res.status){
        this.downloadData = res.data
      }
      else{
        this.downloadData = []
      }
    })
  }

  onExamSelect(e) {
  this.emid = e.EmId;

  this.isBranch = false;
  this.subjectList = [];
  this.filteredsubjectList = [];
  this.BranchList = [];
  this.filteredListBranch = [];
  this.HeadList = [];

  if (e.EmStreams === 'Y') {
    this.isBranch = true;
    this.fetchBranch(e.EmId);
  } else {
    this.fetchSubjects(e.EmId, null);
  }
}


  fetchSubjects(emId, branchId) {
  this.spinner.show();

  const payload: any = { EsEmId: emId };
  if (branchId) payload.EsStrId = branchId;

  this.umsService.getExamSubMapFetch(payload).subscribe(
    res => {
      this.spinner.hide();
      this.subjectList = [];
      this.filteredsubjectList = [];

      if (res.status && res.data?.children) {
        res.data.children.forEach(el => {
          if (el.EsType === 'S') {
            this.subjectList.push(el);
          } else if (el.EsType === 'G') {
            el.children.forEach(g => this.subjectList.push(g));
          }
        });
        this.filteredsubjectList = this.subjectList.slice();
      }
    },
    () => {
      this.spinner.hide();
      this.subjectList = [];
      this.filteredsubjectList = [];
    }
  );
}


  onBranchSelect(branch) {
  this.fetchSubjects(this.emid, branch.StrId);
}


  getSubject(e) {
    // this.getDownloadData();
    this.closeMessage = '';
    this.message = ''
    this.isBranch = false;
    this.spinner.show();
    this.Table = false;
    this.filteredListBranch = [];
    this.filteredsubjectList = [];
    this.HeadList = [];
    this.IAMarksForm.controls['EsId'].setValue('');
    this.subjectList = []
    this.emid = e.EmId;
    if (e.EmStreams == "Y") {
      this.spinner.hide();
      this.isBranch = true;
      this.fetchBranch(e.EmId);
      // this.emid = e.EmId;
    } else {
      this.isBranch = false;
      this.fetchSubjects(e.EmId, null);
      // const payload = {};
      // payload['CoCode'] = this.coCode;
      // payload['CgCode'] = this.CgCode;
      // payload['SnNo'] = this.sessionId;
      // payload['UserId'] = sessionStorage.getItem('userId');
      // this.umsService.getExamSubMapUserWiseFetch(payload).subscribe(res => {

      //   this.spinner.hide();
      //   res.data.forEach(element => {
      //     if (element.EsType == 'S') {
      //       this.subjectList.push(element)
      //     }
      //     else if (element.EsType == 'G') {
      //       element.children.forEach(grpSub => {
      //         this.subjectList.push(grpSub)
      //       });
      //     }
      //     this.filteredsubjectList = this.subjectList.slice();
      //     this.sub = this.filteredsubjectList[0].EsCode
      //   });
      // });
      // this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      //   this.spinner.hide();
      //   res.data.children.forEach(element => {
      //     if (element.EsType == 'S') {
      //       this.subjectList.push(element)
      //     }
      //     else if (element.EsType == 'G') {
      //       element.children.forEach(grpSub => {
      //         this.subjectList.push(grpSub)
      //       });
      //     }
      //     this.filteredsubjectList = this.subjectList.slice();
      //     this.sub = this.filteredsubjectList[0].EsCode
      //   });
      // });
    }

  }


  fetchBranch(id) {
    const payload = {};
    this.filteredsubjectList = [];
    this.subjectList = [];
    this.HeadList = [];
    this.IAMarksForm.controls['EsId'].setValue('');
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }






  getStuMarkSet() {
    this.spinner.show();
    this.savedpayload = this.IAMarksForm.value
    this.SubMarkList = []
    this.Iamarks = 0
    const payload = {};
    payload['CgCode'] = this.savedpayload.college;
    payload['EsParentId'] = this.savedpayload.EsParentId;
    payload['CoCode'] = this.savedpayload.course;
    payload['EmId'] = this.savedpayload.EmId;
    payload['StrId'] = this.savedpayload.Branch;
    payload['SessionId'] = this.savedpayload.SessionId;
    payload['LoginLevel'] = ''
    this.umsService.getStuIAMarks(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.SubMarkList = res.data;
        let data = this.SubMarkList.find(item => item.EsCode === this.subcode);
        this.Iamarks = data.Iamarks;
        if (data.Iamarks == null) {
          let data = {}
          data['message'] = 'IA marks Threshold Not Entered For This Subject.'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.saveDisable = true
        }
        else {
          this.saveDisable = false;
        }
      }
      else {
        // this.spinner.hide();
        // let data = {}
        // data['message'] = 'No IA Iamarks Threshold For This Subject.'
        // data['title'] = 'Alert'
        // data['icon'] = 'fas fa-close'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.saveDisable = true
      }



    });
  }



  File(event: any) {

    const data = {};
    data['message'] = 'Do You Want To Upload This File ?';
    data['title'] = 'Information';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.dialogRef.close();
        const files: FileList = event.target.files;
        const allowedExtensions = ['csv'];

        if (files && files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            const file: File = files[i];
            const extension = file.name.split('.').pop().toLowerCase();

            if (allowedExtensions.includes(extension)) {
              // Process the selected file here (e.g., read its content or upload it)
              // let data = {};
              // data['message'] = 'File Uploaded Successfully';
              // data['title'] = 'Information';
              // data['icon'] = 'fas fa-check';
              // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
              //   AlertBoxComponent,
              //   data
              // );
              // this.SearchEditMarks();
              // this.ControlLock2(parseInt(this.LoginId));
              this.getTextFromFile(file);

            } else {
            }
          }
        }
      }
      else {
        this.dialogRef.close();
      }
    });




  }
 importDataFromCSV(csvText: string): Array<any> {
  const lines = csvText.split(/\r?\n/).filter(line => line.trim() !== '');
  
  const headers = lines[0].split(',').map(h => h.replace(/[\r\n]+/g, '').trim());

  const dataArray1: any[] = [];

  for (let i = 1; i < lines.length; i++) {
    const values = lines[i].split(',').map(v => v.replace(/[\r\n]+/g, '').trim());
    // const values = lines[i]
    const obj: any = {};

    headers.forEach((key, index) => {
      obj[key] = values[index];
    });
    dataArray1.push(obj);
  }

  return dataArray1;
}
  async getTextFromFile(file) {
    // const file: File = event.target.files[0];
    let fileContent = await file.text();
    const importedData = this.importDataFromCSV(fileContent);
    this.processCsvContents(importedData);
  }
  
  // processCsvContents(dataArray): void {
  //   let MarksCounttt = this.Iamarks;
  //   let iserror = false;
  //   const finalArray = [];
  //   var bar = new Promise<void>((resolve, reject) => {
  //     dataArray.forEach((element, index, array) => {
  //       const userId: string | null = sessionStorage.getItem('userId');
  //       const entryDateTime: Date = this.currentDate;
  //       element.UserID = userId;
  //       element.EntryDateTime = entryDateTime;
  //       element.SessionID = this.IAMarksForm.value.SessionId;
  //       element.EmId = this.IAMarksForm.value.EmId;
  //       element.EsId = element.EsId;
  //       element.EsParentId = element.EsParentId;
  //       element.HeadCode = element.HeadCode;
  //       element.CoCode = this.IAMarksForm.value.course;
  //       element.CgCode = this.IAMarksForm.value.college;
  //       element.SubCode = element.SubCode;
  //       element.Branch = element.SubBrId ? parseInt(element.SubBrId) : 0;
  //       if (this.passMarks == parseInt(element['IAMarks']) || parseInt(element['IAMarks']) > this.passMarks) {
  //         element['IAMarksStatus'] = 'P';
  //       } else {
  //         element['IAMarksStatus'] = 'F';
  //       }
        
  //       const matchingDownloadData = this.downloadData.find(d =>
          
  //         d.StuId == element.StuID &&
  //         d.EsIdSubHead == element.EsId &&
  //         d.EsIdIASub == element.EsParentId
  //       );
  //       element.StuIAMarksId = matchingDownloadData ? matchingDownloadData.StuIAMarksId : null;
  //       this.IamarksCounts = this.downloadData[0]['IAMarks'];
  //       element['IAMarks'] = parseInt(element['IAMarks']);
  //       element['ScrutinyID'] = 0;
  
  //       finalArray.push(element);
  //       // API will be called AFTER forEach ends
  //       if (index === array.length - 1) {
  //         // if (this.IamarksCounts == '' || this.downloadData[0]['IAMarks'] == null) {
  //         if (matchingDownloadData.StuIAMarksId == null) {
  //           this.umsService.saveStuIaMarksSet(finalArray).subscribe((res) => {
  //             if (res.status == false) {
  //               iserror = true;
  //               this.errMsg = res.message;
  //             } else {
  //               iserror = false;
  //               this.errMsg = res.message;
  //             }
  //             resolve();
  //           }, (ERROR: HttpErrorResponse) => {
  //             this.spinner.hide();
  //             resolve(); // still resolve to continue .then
  //           });
  //         } else {
  //           this.umsService.updateStuIaMarksSet(finalArray).subscribe((res) => {
  //             if (res.status == false) {
  //               iserror = true;
  //               this.errMsg = res.message;
  //             } else {
  //               iserror = false;
  //               this.errMsg = res.message;
  //               this.ngOnInit();
  //             }
  //             resolve();
  //           }, (ERROR: HttpErrorResponse) => {
  //             this.spinner.hide();
  //             resolve();
  //           });
  //         }
  //       }
  //     });
  //   });
  
  //   bar.then(() => {
  //     if (iserror == false) {
  //       let data = {};
  //       data['message'] = "Uploaded Successfully";
  //       data['title'] = 'Information';
  //       data['icon'] = 'fas fa-check';
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.dialogRef.afterClosed().subscribe((result) => {
  //         this.ShowTable();
  //       });
  //     } else {
  //       let data = {};
  //       data['message'] = this.errMsg;
  //       data['title'] = 'Alert';
  //       data['icon'] = 'fas fa-close';
  //       this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       this.dialogRef.afterClosed().subscribe((result) => {
  //         // this.ShowTable();
  //       });
  //     }
  //   });
  // }
  
  processCsvContents(dataArray): void {
  let iserror = false;
  const finalArray = [];
  const newEntries = [];
  const updateEntries = [];

  const bar = new Promise<void>((resolve, reject) => {
    dataArray.forEach((element, index, array) => {
      const userId: string | null = sessionStorage.getItem('userId');
      const entryDateTime: Date = this.currentDate;

      element.UserID = userId;
      element.EntryDateTime = entryDateTime;
      element.SessionID = this.IAMarksForm.value.SessionId;
      element.EmId = this.IAMarksForm.value.EmId;
      element.EsId = element.EsId;
      element.EsParentId = element.EsParentId;
      element.HeadCode = element.HeadCode;
      element.CoCode = this.IAMarksForm.value.course;
      element.CgCode = this.IAMarksForm.value.college;
      element.SubCode = element.SubCode;
      element.Branch = element.SubBrId ? parseInt(element.SubBrId) : 0;

      const marks = parseInt(element['IAMarks']);
      element['IAMarksStatus'] = (this.passMarks <= marks) ? 'P' : 'F';
      element['IAMarks'] = marks;
      element['SctId'] = 0;

      // Find matching record from downloadData
      const matchingDownloadData = this.downloadData.find(d =>
        d.StuId == element.StuID &&
        d.EsIdSubHead == element.EsId &&
        d.EsIdIASub == element.EsParentId
      );

      element.StuIAMarksId = matchingDownloadData ? matchingDownloadData.StuIAMarksId : null;

      // Split into new or update
      if (element.StuIAMarksId == null) {
        newEntries.push(element);
      } else {
        updateEntries.push(element);
      }

      finalArray.push(element);

      if (index === array.length - 1) {
        // Perform both API calls if needed
        const saveCall = newEntries.length > 0
          ? this.umsService.saveStuIaMarksSet(newEntries).toPromise().catch(err => {
              iserror = true;
              this.errMsg = 'Save API failed';
            })
          : Promise.resolve();

        const updateCall = updateEntries.length > 0
          ? this.umsService.updateStuIaMarksSet(updateEntries).toPromise().catch(err => {
              iserror = true;
              this.errMsg = 'Update API failed';
            })
          : Promise.resolve();

        Promise.all([saveCall, updateCall]).then(() => resolve());
      }
    });
  });

  bar.then(() => {
    let data = {
      message: iserror ? this.errMsg : "Uploaded Successfully",
      title: iserror ? 'Alert' : 'Information',
      icon: iserror ? 'fas fa-close' : 'fas fa-check'
    };

    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(() => {
      if (!iserror) this.ShowTable();
    });
  });
}

  dowload() {
    const link = document.createElement("a");
    link.href = '../../assets/excel/IA Iamarks 2.csv';
    link.download = 'Download';
    link.click()
  }


  download2(event: Event) {
    event.preventDefault();
    const extractedData = this.downloadData.map(element => ({
      StuID: element.StuId,
      SctId: element.SctId,
      Name: element.StuFirstNameEng + " " + element.StuMidNameEng + " " + element.StuLastNameEng,
      RgNo :element.StuRgNo,
      EsParentId : element.EsIdIASub,
      SubCode: element.IASub,
      branch: element.SubBrId ? parseInt(element.SubBrId) : 0,
      EsId: element.EsIdSubHead,
      HeadCode: element.IASubHead,
      // regno: element.StuRgNo,
      IAMarks: element.IAMarks,
    }));

    // Convert array data to CSV format
    const csvContent = this.convertArrayToCSV(extractedData);
    // Create a Blob
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

    // Create a URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a download link
    const link = document.createElement('a');
    link.href = url;
    link.download = 'data.csv'; // You can change the file name if needed
    document.body.appendChild(link);

    // Trigger the download
    link.click();
  }

  convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');
    const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
    return [header, ...rows].join('\n');
  }


  // getIaMarkUserData() {
  //   let payload = {};
  //   payload['SessionId'] = this.IAMarksForm.value.SessionId;
  //   payload['CoCode'] = this.IAMarksForm.value.course;
  //   this.umsService.getIaMarksUser(payload).subscribe((res) => {

  //   })
  // }

}



